import React from "react";
import { Box } from "@mui/material";
import LogoMark from "./LogoMark";
import LogoWordmark from "./LogoWordmark";
import LogoTagline from "./LogoTagline";
import { logoTokens, resolveSize, resolveTone } from "./tokens";

export default function Logo({
  variant = "lockup",
  size = "md",
  tone = "light",
  align = "left",
  tagline,
  showTagline = false,
  decorative = false,
  sx,
  ...rest
}) {
  const dims = resolveSize(size);
  const resolvedTone = resolveTone(tone);
  const ariaLabel = decorative
    ? undefined
    : showTagline && tagline
    ? `${logoTokens.brandName} — ${tagline}`
    : logoTokens.brandName;

  if (variant === "mark") {
    return <LogoMark size={dims.mark} tone={resolvedTone} title={ariaLabel} decorative={decorative} />;
  }

  if (variant === "wordmark") {
    return (
      <Box
        component="span"
        role={decorative ? undefined : "img"}
        aria-label={ariaLabel}
        sx={{ display: "inline-flex", alignItems: "baseline", ...sx }}
        {...rest}
      >
        <LogoWordmark tone={resolvedTone} fontSize={dims.wordmark} />
      </Box>
    );
  }

  return (
    <Box
      role={decorative ? undefined : "img"}
      aria-label={ariaLabel}
      sx={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: align === "center" ? "center" : "flex-start",
        gap: 0,
        minWidth: 0,
        ...sx,
      }}
      {...rest}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: `${dims.gap}px`,
        }}
      >
        <LogoMark size={dims.mark} tone={resolvedTone} decorative />
        <LogoWordmark tone={resolvedTone} fontSize={dims.wordmark} />
      </Box>
      {showTagline && tagline && (
        <LogoTagline
          tone={resolvedTone}
          fontSize={dims.tagline}
          sx={{
            mt: `${Math.round(dims.gap * 0.55)}px`,
            ml: align === "center" ? 0 : `${dims.mark + dims.gap}px`,
            textAlign: align,
          }}
        >
          {tagline}
        </LogoTagline>
      )}
    </Box>
  );
}
